export const DIAGNOSTIC_PROCEDURES_TEMPLATE_LIMIT = 3;

export const DIAGNOSTIC_PROCEDURES_BASE_PATH = 'diagnosticProcedures';

export const getDiagnosticBasePath = (idx: number): string =>
  `${DIAGNOSTIC_PROCEDURES_BASE_PATH}.${idx}`;
